import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { freshBalance } from '@/handle/balanceHandle';
import { changeScene } from '@/handle/chcpHandle';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'Iframe',
  props: {
    href: {
        type: String,
        default: ''
    },
    newStyle: {
        type: String,
        default: 'display: block !important;'
    },
},
  setup(__props) {

let props = __props;

const store = useStore();
const router = useRouter();
let load = 0;

let horStyle = ref<any>({});
watch(
    () => store.state.isHor,
    (newValue: boolean, oldValue: boolean) => {
        if (newValue == true) {
            let screenHeight = document.body.clientHeight; //669
            let screenWidth = document.body.clientWidth; // 390
            let rate = 1583 / 750;
            let rate2 = document.body.clientWidth / document.body.clientHeight;
            if (rate > rate2) {// 当屏幕尺寸比游戏尺寸要大以屏幕尺寸为主
                horStyle.value.width = `${screenHeight}px !important`;
                horStyle.value.height = `${screenHeight / rate}px !important`;
            } else {
                horStyle.value.width = `${window.screen.height}px !important`;
                horStyle.value.height = `${window.screen.height * rate}px !important`;
            }

            // horStyle.value.height = `${document.body.clientWidth}px !important`;
            // horStyle.value.width = `${document.body.clientHeight}px !important`;
        } else {
            horStyle.value = {};
        }
    }
)


let isShowExit: any = ref(false);

onMounted(() => {
    // window.addEventListener("message", function(e) {
    //     console.log("message:", e);
    //     console.log("e.origin:", e.origin);
    //     if (e.origin.indexOf(window.location.hostname) != -1) {
    //         onExit();
    //     }
    // });

    let iframe = document.getElementById("full_screen");
    if (iframe) {
        iframe.addEventListener('load', () => {
            console.log("load:", load);
            load ++;
            if(load == 2){
                onExit();
                store.state.isHor = false;
            }
            //window.postMessage("message go home", props.href);
        });
    }
    window.addEventListener("message", onEventBack);
});

function handleError() {
    onExit();
}

function onClose() {
    isShowExit.value = !isShowExit.value;
}

/**改变屏幕方向 竖屏 */
function reqChangeScene() {
    if (process.env.VUE_APP_ISAPP == "true") {
        changeScene("t");
    }
}

async function onExit() {
    load = 0;
    store.state.gameUrl = "";
    store.state.isShowMaskBg = true;
    reqChangeScene();
    setTimeout(() => {
        store.state.isShowMaskBg = false;
    }, 2000);
    try {
        freshBalance(true);
    } catch (error) {
        console.log(error);
    }
}

function onEventBack(e: any) {
    let data = e.data;
    if (data) {
        switch (data.msgType) {
            case "cc_game_web_shop"://打开充值
            goDeposit(data.msgData);
            break;
        }
    }
}

function goDeposit(data: any) {
    router.push('/deposit');
    onExit();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["all", {horSize: _unref(store).state.isHor}])
  }, [
    _createElementVNode("iframe", {
      ref: "iframe",
      id: "full_screen",
      class: _normalizeClass(["full-screen", {hor: _unref(store).state.isHor}]),
      style: _normalizeStyle([__props.newStyle, _unref(horStyle)]),
      src: __props.href,
      frameborder: "0",
      height: "100%",
      width: "100%",
      scrolling: "no",
      allow: "fullscreen",
      onerror: handleError
    }, null, 14, _hoisted_1)
  ], 2))
}
}

})